function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import Vue from 'vue';
import { VCheckbox } from 'vuetify/lib';
import { sortBy } from 'lodash';
import FormMixin from '../form.mixin';

var DefectLocationSelection = /*#__PURE__*/function () {
  function DefectLocationSelection() {
    _classCallCheck(this, DefectLocationSelection);
  }

  _createClass(DefectLocationSelection, null, [{
    key: "register",
    value: function register() {
      Vue.component('roche-defect-location-selection', {
        template: "\n        <div v-if=\"locations\">\n          <h4>{{ title }}</h4>\n\n          <div class=\"defect-location-container-wrapper scrollbar-none\">\n            <div class=\"defect-location-container scrollbar-none\">\n              <div class=\"defect-location-wrapper\">\n                <img class=\"defect-location-image\" :src=\"$store.getters['forms/fullDosageFormDefectLocations'].imageDAMPath\" :alt=\"dosageForm.description\" />\n                <div \n                  v-for=\"part in locations\" \n                  :key=\"part.imageSectionValue\" \n                  class=\"defect-location\" \n                  :class=\"{ 'is-active': defectLocations.includes(part.imageSectionLabel) }\" \n                  :style=\"'flex: 0 0 ' + part.percentage + '%'\"\n                  :title=\"part.imageSectionLabel\"\n                  >\n                  <v-checkbox \n                    v-model=\"defectLocations\" \n                    :value=\"part.imageSectionLabel\"\n                    :label=\"part.imageSectionLabel\" \n                    :ripple=\"false\" \n                    @change=\"handleInput\"\n                  ></v-checkbox>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      ",
        components: {
          VCheckbox: VCheckbox
        },
        data: function data() {
          return {
            defectLocations: []
          };
        },
        mixins: [FormMixin],
        props: {
          dosageForm: {
            type: Object,
            "default": function _default() {}
          },
          title: {
            type: String,
            "default": ''
          }
        },
        computed: {
          locations: function locations() {
            if (!this.$store.getters['forms/fullDosageFormDefectLocations']) {
              return null;
            }

            return sortBy(this.$store.getters['forms/fullDosageFormDefectLocations'].imageSections, 'orderNo');
          }
        },
        methods: {
          handleInput: function handleInput() {
            this.$store.commit('forms/SET_FORM', _objectSpread(_objectSpread({}, this.$store.getters['forms/form']), {}, {
              defectLocations: this.defectLocations
            }));
          }
        }
      });
    }
  }]);

  return DefectLocationSelection;
}();

export default DefectLocationSelection;